import AgentCreateShortModal from "./agent-create-short-modal";

export default AgentCreateShortModal;
